import TableReportHelper from "report/helper";

export default async function indicadorReportSummary( // pdf da visita ou pdf do laudo
    indicador,
    visita,
    tipoName,
    params,
    chartCallBack = null,
    unit = "%",
    fieldMediaConformidade = "conformidade",
    metaShow,
    showMeta = true,
    additionalColumn,
    secondChartCallBack = null
) {
    const h = new TableReportHelper(visita.data);
    const IndicadorClass = indicador.constructor;

    let averageConformidade = indicador.getAverage(visita, fieldMediaConformidade, tipoName);

    const averageAfericao = indicador.getAverage(visita, "afericao", tipoName);
    const averageDosagemRecomendada = indicador.getAverage(visita, "dosagemRecomendada", tipoName);
    const averageNaoConforme = indicador.getAverage(visita, "arrowNaoConforme", tipoName, params)
    const status = IndicadorClass.getConformidadeStatus(indicador.getAverage(visita, "conformidade", tipoName), params.meta, null, visita.cliente);

    // Levantamento de Cigarrinhas (LC) // pdf da visita ou pdf do laudo
    let averageConformidadeAdultas = indicador.getAverage(visita, "numAdultasMetro", tipoName)
    const statusAdultas = IndicadorClass.getConformidadeStatus(indicador.getAverage(visita, "numAdultasMetro", tipoName), params.metaMaxAdultas, null, visita.cliente)

    // Levantamento de Broca Manual (LBM) // pdf da visita ou pdf do laudo
    let averageConformidadeBrocasInternas = indicador.getAverage(visita, "percentBrocasInternas", tipoName)
    const statusBrocasInternas = IndicadorClass.getConformidadeStatus(averageConformidadeBrocasInternas, params.metaBrocasInternas, null, visita.cliente)

    if (averageConformidade) {

        averageConformidade = averageConformidade.toFixed(2)
    }
    async function getChart() {
        if (chartCallBack) {
            return chartCallBack(averageConformidade, status);
        } else {
            return null;
        }
    }

    if (averageConformidade !== undefined) {
        let title = [], value = []

        title.push(h.title(IndicadorClass.fullName, { rowSpan: 2, alignment: "center" }),)
        value.push(h.empty(),)

        if (additionalColumn) {
            title.push(h.title(additionalColumn.title, { alignment: "center" }))
            value.push(h.text(additionalColumn.value, { alignment: "center" }))
        }

        if (showMeta) {
            title.push(h.title(`Meta(${unit})`, { alignment: "center" }),)
            value.push(h.number(metaShow || params.meta, { alignment: "center" }),)
        }

        title.push(h.title(`Result(${unit})`, { alignment: "center" }))
        value.push(h.conformidade(averageConformidade, status, { alignment: "center" }))

        const content = [
            h.row(...title),
            // prettier-ignore
            h.row(...value),
        ];

        if (averageAfericao > 0) {
            content.push(
                h.row(
                    h.text("Quantidade Aferida"),
                    h.number(averageAfericao, { alignment: "center" }),

                    averageAfericao > averageDosagemRecomendada
                        ? h.arrowUp(status, { alignment: "center" })
                        : h.arrowDown(status, { alignment: "center" })
                )
            );
        }

        if (averageNaoConforme !== 0 && averageNaoConforme) {
            let statusArrowUp = parseFloat(averageNaoConforme.percentAcima) > 0 ? h.arrowUp("Ruim"/*status*/, { alignment: "center" }) : h.hyphen({ alignment: "center" })
            let statusArrowDown = parseFloat(averageNaoConforme.percentAbaixo) > 0 ? h.arrowDown("Ruim"/*status*/, { alignment: "center" }) : h.hyphen({ alignment: "center" })

            let min = params.intervaloMin
                ? params.intervaloMin
                : averageNaoConforme.estacao === "Verão"
                    ? params.intervaloMinVerao
                    : params.intervaloMinInverno
            let max = params.intervaloMax
                ? params.intervaloMax
                : averageNaoConforme.estacao === "Verão"
                    ? params.intervaloMaxVerao
                    : params.intervaloMaxInverno

            content.push(h.row(h.title(`Intervalo: (${min}, ${max})`, { alignment: "center", colSpan: 3 }),))

            content.push(
                h.row(
                    h.text(`Acima`),
                    statusArrowUp,
                    h.number(averageNaoConforme.percentAcima, { alignment: "center" }),
                )
            )
            content.push(
                h.row(
                    h.text(`Abaixo`),
                    statusArrowDown,
                    h.number(averageNaoConforme.percentAbaixo, { alignment: "center" }),
                )
            )
        }

        content.push(
            h.row(await getChart()),

            // prettier-ignore
            h.row(
                h.text(
                    status,
                    {
                        alignment: "center",
                        fontSize: 10,
                        colSpan: additionalColumn ? 4 : 3
                    }
                ),
            )
        );

        // TODO: 2365 padronização do código dos gráficos extra
        if (IndicadorClass.abbrev === 'LC') {
            let title2 = [], value2 = [], otherCharts = []

            title2.push(h.title("Adultas", { rowSpan: 2, alignment: "center" }),)
            value2.push(h.empty(),)

            title2.push(h.title(`Meta(${unit})`, { alignment: "center" }),)
            value2.push(h.number(params.metaMaxAdultas, { alignment: "center" }),)

            title2.push(h.title(`Result(${unit})`, { alignment: "center" }))
            value2.push(h.conformidade(averageConformidadeAdultas, statusAdultas, { alignment: "center" }))

            if (secondChartCallBack) {
                otherCharts.push(h.row(await secondChartCallBack(averageConformidadeAdultas, statusAdultas)))
            }

            content.push(
                h.row(...title2),
                h.row(...value2),
            )

            content.push(
                ...otherCharts,

                h.row(
                    h.text(
                        statusAdultas,
                        {
                            alignment: "center",
                            fontSize: 10,
                            colSpan: additionalColumn ? 4 : 3
                        }
                    ),
                )
            )
        }

        if (IndicadorClass.abbrev === 'LBM') {
            let title2 = [], value2 = [], otherCharts = []

            title2.push(h.title("Brocas Internas", { rowSpan: 2, alignment: "center" }),)
            value2.push(h.empty(),)

            title2.push(h.title(`Meta(%)`, { alignment: "center" }),)
            value2.push(h.number(params.metaBrocasInternas, { alignment: "center" }),)

            title2.push(h.title(`Result(%)`, { alignment: "center" }))
            value2.push(h.conformidade(averageConformidadeBrocasInternas, statusBrocasInternas, { alignment: "center" }))

            if (secondChartCallBack) {
                otherCharts.push(h.row(await secondChartCallBack(averageConformidadeBrocasInternas, statusBrocasInternas)))
            }

            content.push(
                h.row(...title2),
                h.row(...value2),
            )

            content.push(
                ...otherCharts,

                h.row(
                    h.text(
                        statusBrocasInternas,
                        {
                            alignment: "center",
                            fontSize: 10,
                            colSpan: additionalColumn ? 4 : 3
                        }
                    ),
                )
            )
        }

        return h.panel(
            content,
            {
                widths: additionalColumn ? ["*", 50, 50, 50] : ["*", 50, 50],
                unbreakable: true,
                layout: "borders"
            }
        )
    } else {
        return null;
    }
}
